import { render } from "./BasicTable.vue?vue&type=template&id=286aa7df&scoped=true"
import script from "./BasicTable.vue?vue&type=script&lang=js"
export * from "./BasicTable.vue?vue&type=script&lang=js"

import "./BasicTable.vue?vue&type=style&index=0&id=286aa7df&lang=scss&scoped=true"

import exportComponent from "/Users/elodie/Desktop/Dev/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-286aa7df"]])

export default __exports__